const navigation = {
  id: 'group-dashboard-loading-unique',
  title: 'ERP',
  type: 'group',
  children: [
    {
      id: 'report',
      title: 'Report',
      type: 'item',
      icon: 'ph ph-chart-bar',
      url: '/'
    },
    {
      id: 'warehouse',
      title: 'Warehouse',
      type: 'item',
      icon: 'ph ph-warehouse',
      url: '/warehouse'
    },
    {
      id: 'product',
      title: 'Product',
      type: 'item',
      icon: 'ph ph-shopping-bag',
      url: '/product'
    },
    {
      id: 'po',
      title: 'Purchase Order',
      type: 'item',
      icon: 'ph ph-shopping-cart',
      url: '/purchase-order'
    },
    {
      id: 'so',
      title: 'Sales Order',
      type: 'item',
      icon: 'ph ph-currency-dollar',
      url: '/sales-order'
    },
    {
      id: 'gr',
      title: 'Goods Receipt',
      type: 'item',
      icon: 'ph ph-truck-trailer',
      url: '/goods-receipt'
    },
    {
      id: 'inventory',
      title: 'Inventory',
      type: 'item',
      icon: 'ph ph-package',
      url: '/inventory'
    },
    {
      id: 'do',
      title: 'Dispatch Order',
      type: 'item',
      icon: 'ph ph-truck',
      url: '/dispatch-order'
    },
    {
      id: 'supplier',
      title: 'Supplier',
      type: 'item',
      icon: 'ph ph-buildings',
      url: '/supplier'
    },
    {
      id: 'users',
      title: 'Management Users',
      type: 'item',
      icon: 'ph ph-users',
      url: '/users'
    },
    {
      id: 'audit',
      title: 'Audit Log',
      type: 'item',
      icon: 'ph ph-shield-check',
      url: '/audit-log'
    }
  ]
};

export default navigation;
